// Module
var code = "<span class=\"edit-btn _delete\" ng-click=\"deleteDomain(row); animateSize($event)\">\n    <i class=\"close icon-X\" am-tooltip=\"top center to bottom center\" title=\"Delete\"></i>\n</span>\n<div title=\"{{row.name}}\" class=\"delete-txt\">\n\t{{row.name}}\n</div>";
// Exports
module.exports = code;